import { defineComponent } from 'vue';
import Title from './title.vue';
import { commentData } from '../content.js';
import Swiper from 'swiper'; // 引入库
import 'swiper/swiper-bundle.min.css';
export default defineComponent({
  name: 'comment',
  data() {
    return {
      commentData,
      mySwiper: null,
      activeIndex: 0,
      timer: 0
    };
  },
  components: {
    Title
  },
  mounted() {
    this.initAni();
    this.timer = setInterval(() => {
      var _this$mySwiper;
      if (this.mySwiper.activeIndex + 3 < 6) {
        this.mySwiper.activeIndex++;
      } else {
        this.mySwiper.activeIndex = 0;
      }
      this.activeIndex = this.mySwiper.activeIndex;
      (_this$mySwiper = this.mySwiper) === null || _this$mySwiper === void 0 || _this$mySwiper.slideTo(this.mySwiper.activeIndex);
    }, 3000);
  },
  methods: {
    initAni() {
      this.mySwiper = new Swiper('.mySwiper', {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        slidesPerView: 3,
        spaceBetween: 24,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          slideChange: silde => {
            this.activeIndex = silde.activeIndex;
          }
        }
      });
    },
    progess() {
      let progessDefalt = 100 / this.commentData.length;
      let progess = 0;
      if (this.activeIndex === this.commentData.length - 3) {
        progess = 100;
      } else {
        progess = progessDefalt * (this.activeIndex + 3);
      }
      return progess + '%';
    },
    next() {
      var _this$mySwiper2;
      this.mySwiper.activeIndex++;
      this.activeIndex = this.mySwiper.activeIndex;
      (_this$mySwiper2 = this.mySwiper) === null || _this$mySwiper2 === void 0 || _this$mySwiper2.slideTo(this.mySwiper.activeIndex);
    },
    prev() {
      var _this$mySwiper3;
      this.mySwiper.activeIndex--;
      this.activeIndex = this.mySwiper.activeIndex;
      (_this$mySwiper3 = this.mySwiper) === null || _this$mySwiper3 === void 0 || _this$mySwiper3.slideTo(this.mySwiper.activeIndex);
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
});